import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Stack, Typography } from "@mui/material";
import WBTextField from "components/input/WBTextField";
import { Controller, useForm } from "react-hook-form";
import CountdownTimer from "services/utils/Counter";
import { Cookie } from "@mui/icons-material";
import { getCookie, removeCookie, setCookie } from "services/utils/CookieHandler";
import useFetch from "services/hooks/useFetch";
import { ApiUrls } from "services/utils/globalVariables";
import { LoginHeading, LoginLabel } from "components/typography/text";

export default function LoginFormNumberValidation({ setLoading, loginData, setStage, setCode, code }) {

    const [isZero, setIsZero] = useState(false)

    const { CheckCode, JwtLogin, CheckUserName } = ApiUrls

    const [{}, fetchCode] = useFetch(CheckCode, "post")
    const [{}, fetchJwt] = useFetch(JwtLogin, "post")
    const [{}, fetchResend] = useFetch(CheckUserName, "post")

    const { handleSubmit, control, setError, clearErrors, reset } = useForm();

    let count = 45
    
    const handleZeroFunction = () => {
        setIsZero(true)
    }

    const handleResetCounter = () => {
        setIsZero(false)
        sendCodeAgain()
        document.getElementById("LoginValidation").focus()
    }

    const submitLoginValidation = (data) => {
        setLoading(true)
        const bodyObj = {
            "UserName": loginData,
            "Code": data.LoginValidation,
            "LoginMethod": "CodeCreated",
            "PortalId": "0",
            "IsNameRequired": true,
            "IsDynamicPass": true,
            "IsPhoneNumber": true,
            "MergeUsers": false
        }
        setCode(data.LoginValidation)
        fetchCode(bodyObj, handleSubmitNumberValid)
    }

    const handleSubmitNumberValid = (res) => {

        if(res == "WrongCode") {
            setError("LoginValidation", { type: "custom", message: "کد وارد شده اشتباه است" })
        } else {
            clearErrors("LoginValidation")
        }

        if(res == "SetName") {
            setStage(3)
        }

        if(res.includes("OK")) {
            fetchJwt({u: loginData, p: document.getElementById("LoginValidation").value + "777"}, handleToken)
        }
        //Setting button loader to false to stop loader
        setLoading(false)
    }

    const sendCodeAgain = () => {
        reset({LoginValidation: ""})
        const staticBody = {
            "UserName": loginData,
            "IsPhoneNumber": true,
            "SmsToken": "R$8jkg%dksfy@sdf23",
            "SmsMessage": "پاکسرشت هوم",
            "IsDynamicPass": true,
            "PortalId": "0",
            "MergeUsers": false
        }
        fetchResend(staticBody)
    }

    const handleToken = (res) => {
        setCookie("loginData", res, 1/24)
        if(getCookie("loginData")) {
            window.location.href = "/"
        }
    }

    const submitLoginValidationChange = (e) => {
        if(e.target.value.length == 4) {
            document.getElementById("SubmitNumberCode").click()
        }
    }

    return (
        <Stack spacing={2}>
            <LoginHeading>کد تایید را وارد نمایید</LoginHeading>
            <LoginLabel>کد تایید برای شماره  { loginData } ارسال گردید </LoginLabel>
            <Stack
                component="form"
                onSubmit={handleSubmit(submitLoginValidation)}
            >
                <WBTextField
                    control={control}
                    name="LoginValidation"
                    type="number"
                    defualtValue=""
                    autoComplete="off"
                    isRequired={true}
                    errorText="لطفا کد عبور را وارد نمایید" 
                    autoFocus={true}        
                    innerFunction={submitLoginValidationChange} 
                    id="LoginValidation"          
                />
                <Button sx={{display: "none !important"}} id="SubmitNumberCode" type="submit">submitData</Button>
            </Stack>
            <Box sx={{mt: "64px !important", display: "flex", justifyContent: "center"}}>
                {
                    isZero ? 
                        <Button onClick={handleResetCounter} sx={{color : "#00A8F0", fontWeight: "300"}}>ارسال مجدد کد</Button>
                    :
                        <Typography fontWeight="300" fontSize="14px" textAlign="center">ارسال مجدد کد تا {<CountdownTimer seconds={count} handleZeroFunction={handleZeroFunction} />} ثانیه دیگر</Typography>
                }
            </Box>
        </Stack>
    )
}